import SystemAPI from '@/apis/business/common/system-api.js'
import { UserTypeName, UserType } from '@/common/constant.ts'
import { getUserType } from '@/utils/auth'
import { getEnvConfig } from '@/utils/env-variables'
import Analytics, { collectDataISMAC } from '@/utils/fire-base'

const freeze = Object.freeze

// Các key trong context data
const ContextDataKey = freeze({
  OrganizationID: 'OrganizationID',
  OrganizationName: 'OrganizationName',
  SchoolLevel: 'SchoolLevel',
  UserID: 'UserID',
  UserType: 'UserType',
  PhoneNumber: 'PhoneNumber',
  FirstName: 'FirstName',
  LastName: 'LastName',
  UserName: 'UserName',
  FullName: 'FullName',
  Image: 'Image',
  ImageFrame: 'ImageFrame',
  IsEMIS: 'IsEMIS',
  Email: 'Email',
  RoleList: 'RoleList',
  SISAPCode: 'SISAPCode'
})

// Khởi tạo contextData
const initContextData = async function () {
  const me = this
  const reponse = await SystemAPI.getContextData()
  if (reponse.IsSuccess) {
    logISMAC(reponse.Data, me)
    setContextData(reponse.Data)
    setTitle(me.$route.meta?.title)
  }
}

const logISMAC = async function (data, me) {
  const userType = getUserType()
  const bussinessType = 'DashBoard_OverView'
  const ISMACConfig = getEnvConfig('ISMACConfig') || {}
  const ISMACData = {
    appVer: getEnvConfig('version') || '',
    viewName: Analytics.resource.BusinessType[bussinessType]
  }
  let appId = ''
  let userPostFix = ''
  switch (userType) {
    case UserType.Teacher:
      userPostFix = data.PhoneNumber
      appId = ISMACConfig.isInfo.teacher
      break
    case UserType.Student:
      userPostFix = data.UserName
      appId = ISMACConfig.isInfo.student
  }

  ISMACData.appId = appId
  ISMACData.uuId = `${appId}_${userPostFix}`
  collectDataISMAC(ISMACData)
}

/**
 * @description Lưu context data
 * @param {*} context
 * @author PHNam
 */
const setContextData = function (context) {
  window.__contextData = context
}

const TitleConst = freeze({
  HomeWork: 'Ôn tập',
  Exam: 'Kiểm tra',
  Practice: 'Ôn luyện'
})

/**
 * @description Lưu context data
 * @param {*} context
 * @author NNAnh3
 */
const setTitle = function (titleName) {
  if (!titleName) {
    titleName = TitleConst.HomeWork
  }
  if (window.__contextData) {
    const orgName = getContextData(ContextDataKey.OrganizationName)
    const userTypeName =
      getContextData(ContextDataKey.UserType) === UserType.Teacher
        ? UserTypeName.Teacher
        : UserTypeName.Student
    const schoolName = orgName ? ` - ${orgName}` : ''
    const title = `${titleName} (${userTypeName})${schoolName} | MISA EMIS`
    document.title = title
  }
}

/**
 * @description Lấy dữ liệu trong contextdata
 * @param {*} key Key cần lấy trong contextData
 * @returns
 * @author PHNam
 */
const getContextData = function (key) {
  if (window.__contextData) {
    return key ? window.__contextData[key] : window.__contextData
  }
}

export { initContextData, setContextData, getContextData, ContextDataKey, setTitle, TitleConst }
